import { StropheConnection, StropheInstance } from "./types";

interface ClassType<T extends StrophePlugin> {
    build(): T;
}

export abstract class StrophePlugin {
    protected PLUGIN_NAME = '';

    protected connection: StropheConnection = null;

    public constructor(pluginName: string) {
        this.PLUGIN_NAME = pluginName;
    }

    public static register<T extends StrophePlugin>(_class: ClassType<T>, stropheInstance: StropheInstance) {
        const plugin = _class.build();
        stropheInstance.addConnectionPlugin(plugin.PLUGIN_NAME, plugin);
    }

    // called by the Strophe.Connection constructor
    public init(conn: StropheConnection): void {
        this.connection = conn;
    }
}
